// node_modules
import { FC, useContext, useState } from "react";
import { Link } from "react-router-dom";
// Components
import { FindestBookmark, FindestButton } from "Components";
// Controllers
import { ArticleControllerSingleton } from "Controllers";
// Types
import { TWebDocumentDTO } from "Types";
// styles
import styles from "./webDocument.module.scss";
// Enums
import { EntityTypeEnum } from "Enums";
// Contexts
import { CaseContext, AuthContext } from "Stores";

type TWebDocumentProps = {
    webDto: TWebDocumentDTO
}

export const WebDocument: FC<TWebDocumentProps> = ({ webDto }: TWebDocumentProps) => {
    const [webDocument, setWebDocument] = useState<TWebDocumentDTO | null>(null);

    // Contexts
    const { caseState } = useContext(CaseContext);
    const { authState } = useContext(AuthContext);

    const onClickDocument = async () => {
        if (webDocument === null) {
            const fullDocument = await ArticleControllerSingleton.getWebPageAsync(webDto.id);
            setWebDocument(fullDocument);
        } else {
            setWebDocument(null);
        }
    };

    return (
        <div className={styles.webDocument}>
            <div className={styles.documentHeader}>
                <div className={styles.documentBookmarkContainer}>
                    <FindestBookmark entity={webDto} entityType={EntityTypeEnum.WebPageType} isEntityBookmarked={true} isEditable={authState.hasAccessToDynamicDelivery && caseState.isDynamicDelivery}/>
                </div>
                <div className={styles.documentTitleInformationContainer}>
                    <div className={styles.documentTitleContainer}>
                        <span className={styles.documentTitle} onClick={onClickDocument}>{webDto.title}</span>
                    </div>
                </div>
            </div>
            {webDocument ?
                <div className={styles.fullInfo}>
                    {webDocument.url ?
                        <div className={[styles.infoColumn, styles.metadataContainer].join(" ")}>
                            <Link to={{ pathname: webDocument.url }} target={"_blank"} rel={"noopener noreferrer"} >
                                <FindestButton title="Link to Website" />
                            </Link>
                        </div>
                        : <></>
                    }
                    <div className={styles.infoColumn}>
                        <h5>Web text</h5>
                        {webDocument.webText ?
                            <h6>{webDocument.webText}</h6>
                            : <h6>No web text available</h6>
                        }
                    </div>
                </div>
                : <></>
            }
        </div>
    );
};